import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { NavLink } from "react-router-dom";

const hpMainSlider = {
    dots: false,
    autoplay: true,
    infinite: true,
    arrows: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };


const Jewellery_Accessories1 = () => {
    return (
        <>
        <div id="maincarousel">
        <div className="container">
          <div className="row">
                              <div className="col-lg-3">
                              <div class="sc-gWXbKe hoZTIr __pf" id="__pf">
                              <div data-pf-type="Block" className="sc-bilyIR cCHonK pf-16_">
                    <h3 data-pf-type="Heading" className="sc-ctqQKy ioCblW pf-17_">
                      <i className="sc-gIDmLj huzWMp pf-18_ pfa pfa-bars" data-pf-type="Icon" />
                     
                        <NavLink 
                            to={'/jewellery'}
                            exact
                            style={{color:'#fff'}}
                          >
                        <span data-pf-type="Text" className="sc-jtXEFf kGfXVs pf-19_">
                        Jewellery Accessories
                        </span>
                        </NavLink>
                    </h3>
                    <div className="sc-bilyIR cCHonK pf-20_">
                    <NavLink 
                            to={'/necklaces'}
                            exact
                          >
                    
                      <div data-pf-type="Image" className="sc-evcjhq RvYYJ pf-21_">
                        <img
                          src="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/1659604165020PQzoH5.png"
                          srcSet="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/1659604165020PQzoH5.png 1536w"
                        />
                      </div>
                      <h3 data-pf-type="Heading" className="sc-ctqQKy ioCblW pf-22_">
                        <span data-pf-type="Text" className="sc-jtXEFf kGfXVs pf-24_">
                        Necklaces
                        </span>
                      </h3>
                      </NavLink>
                      </div>
                    <div className="sc-bilyIR cCHonK pf-25_"
                    >
                      <NavLink 
                            to={'/earrings'}
                            exact
                          >
                      <div data-pf-type="Image" className="sc-evcjhq RvYYJ pf-26_">
                        <img
                          src="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/16596042247935g0wRM.png"
                          srcSet="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/16596042247935g0wRM.png 1536w"
                        />
                      </div>
                      <h3 data-pf-type="Heading" className="sc-ctqQKy ioCblW pf-27_">
                        <span data-pf-type="Text" className="sc-jtXEFf kGfXVs pf-29_">
                        Earrings
                        </span>
                      </h3>
                      </NavLink>
                    </div>
                    
                    <div
                      
                      className="sc-bilyIR cCHonK pf-30_"
                    >
                      <NavLink 
                            to={'/jewellery-boxes-care'}
                            exact
                          >
                      <div data-pf-type="Image" className="sc-evcjhq RvYYJ pf-31_">
                        <img
                          src="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/1659604286964STZPlZ.png"
                          srcSet="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/1659604286964STZPlZ.png 1536w"
                        />
                      </div>
                      <h3 data-pf-type="Heading" className="sc-ctqQKy ioCblW pf-32_">
                        <span data-pf-type="Text" className="sc-jtXEFf kGfXVs pf-34_">
                        Jewellery Boxes Care
                        </span>
                      </h3>
                      </NavLink>
                    </div>
                    <div
                      
                      className="sc-bilyIR cCHonK pf-35_"
                    >
                      <NavLink 
                            to={'/pendants'}
                            exact
                          >
                      <div data-pf-type="Image" className="sc-evcjhq RvYYJ pf-36_">
                        <img
                          src="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/1659604334820g7Cdhq.png"
                          srcSet="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/1659604334820g7Cdhq.png 1536w"
                        />
                      </div>
                      <h3 data-pf-type="Heading" className="sc-ctqQKy ioCblW pf-37_">
                        <span data-pf-type="Text" className="sc-jtXEFf kGfXVs pf-39_">
                        Pendants
                        </span>
                      </h3>
                      </NavLink>
                    </div>
                    <div
                      
                      className="sc-bilyIR cCHonK pf-40_"
                    >
                      <NavLink 
                            to={'/body-jewellery'}
                            exact
                          >
                      <div data-pf-type="Image" className="sc-evcjhq RvYYJ pf-41_">
                        <img
                          src="	https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/1659604388494jStJD8.png"
                          srcSet="	https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/1659604388494jStJD8.png"
                        />
                      </div>
                      <h3 data-pf-type="Heading" className="sc-ctqQKy ioCblW pf-42_">
                        <span data-pf-type="Text" className="sc-jtXEFf kGfXVs pf-44_">
                        Body Jewellery
                        </span>
                      </h3>
                      </NavLink>
                    </div>
                    <div
                      
                      className="sc-bilyIR cCHonK pf-45_"
                    >
                      <NavLink 
                            to={'/rings'}
                            exact
                          >
                      <div data-pf-type="Image" className="sc-evcjhq RvYYJ pf-46_">
                        <img
                          src="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/1659604457196tYBClg.png"
                          srcSet="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/71/1659604457196tYBClg.png 1536w"
                        />
                      </div>
                      <h3 data-pf-type="Heading" className="sc-ctqQKy ioCblW pf-47_">
                        <span data-pf-type="Text" className="sc-jtXEFf kGfXVs pf-49_">
                        Rings
                        </span>
                      </h3>
                      </NavLink>
                    </div>
                  </div>
                  </div>
                              </div>
            <div className="col-lg-9"> <Slider {...hpMainSlider}>
            <div className="item">
                <a href="/jewellery-boxes-care" className="banner"><img src="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/61/1659071098969Y7QPTL.png" style={{width: '100%'}} className='image_banner' alt="首页面（新）" /></a>
            </div>
            <div className="item">
                <a href=" /jewellery" className="banner"><img src="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/61/16590710989611HjH8G.png" style={{width: '100%' }} className='image_banner' alt="Modern L-Shaped Sofa Price" /></a>
            </div>
            {/* <div className="item">
                <a href="/products/sofa" className="banner"><img src="https://static-sellercentral.shopperr.in/images/supplier/6049a93d223709632c7962b2/2022/61/1657711628171PZ80nC.png" style={{width: '100%'}} alt="Sofa S1015" /></a>
            </div> */}
            
            
            
        </Slider></div>
          </div>
        </div>
        <div className='container' style={{marginTop:'20px'}}>
            <div className='row sc-gWXbKe hoZTIr __pf' id="__pf">
                <div className='col-lg-6'>
                <a href="/novelty-jewellery">
                <div data-pf-type="Column" className="sc-hAcGzb bAQARH pf-571_jew">
                <h3 data-pf-type="Heading" className="sc-ctqQKy ioCblW pf-58_">
                <span data-pf-type="Text" className="sc-jtXEFf kGfXVs pf-60_"><br />
                <span style={{'font-weight': 'bold'}}></span>
                <br />

                </span>
                </h3>
                </div> 
                </a>
                </div>
                <div className='col-lg-6 ' >
                <a href="/jewellery-boxes-care">
                <div data-pf-type="Column" className="sc-hAcGzb bAQARH pf-611_jew">
                    <h3 data-pf-type="Heading" className="sc-ctqQKy ioCblW pf-62_">
                        <span data-pf-type="Text" className="sc-jtXEFf kGfXVs pf-64_">
                        
                        <br />
                        <span style={{ fontWeight: 700 }}></span>
                        <br />
                        </span>
                    </h3>
                    </div>
</a>
                </div>
            </div>
        </div>
       
        </div>
        </>

    )
}

export default Jewellery_Accessories1;
